import React, { ReactElement } from 'react'
import { Box, Spinner } from '@ally/metronome-ui'
import styled from 'styled-components'

const SpinnerWrapper = styled(Box)`
  width: 100%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  min-height: 82px;
`

export const Loader = (): ReactElement => {
  return (
    <SpinnerWrapper>
      <Spinner altText="We're loading your information" />
    </SpinnerWrapper>
  )
}
